import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../hooks/store';
import { requestsPut } from '../../store/requestsSlice';
import { Request, Slot } from '../../types';
import { get, put } from '../../utils/api';
import DateSwitch from '../common/DateSwitch';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import './RequestChangeSlot.css';

export interface RequestChangeSlotProps {
    request: Request;
    onClose: () => void;
};

const RequestChangeSlot: FC<RequestChangeSlotProps> = ({ request, onClose }) => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language === 'en' ? 'en' : 'ru';
    const user = useAppSelector(store => store.auth.user);
    const slots = useAppSelector(store => store.slots);
    const dispatch = useAppDispatch();
    const myRequests = useAppSelector(store => store.requests);
    const [ currentDate, setCurrentDate ] = useState('');
    const [ error, setError ] = useState('');
    const [ otherRequests, setOtherRequests ] = useState<Request[]>([]);
    // Мы устанавливаем, но не используем isLoading т.к. компонент постоянно
    // запрашивает данные при обновлении запросов пользователя по таймеру и
    // если показывать индикатор загрузки он будет бесить
    // eslint-disable-next-line
    const [ isLoading, setIsLoading ] = useState(false);

    // Запрашиваем запросы участника
    useEffect(() => {
        const fetchData = async (attendee_id: number) => {
            setIsLoading(true);
            setError('');
            const result = await get('/requests', { attendee_id });
            if(result.error) {
                setError(result.error.text[lang]);
            }
            if(result.data) {
                const requests = result.data.requests as Request[];
                setOtherRequests(requests);
            }
            setIsLoading(false);
        };
        if(!user) return;
        const attendee_id = request.from_id === user.id ? request.to_id : request.from_id;
        fetchData(attendee_id);
	}, [ request, lang, user ]);

    // Меняем слот у запроса
    const changeSlot = async (slot: Slot) => {
    //  Больше не надо выводить предупреждение т.к. смена слота
    //  не возвращаетс запрос обратно в неподтвержденные
    //  if(request.status === 'approved') {
    //      if(!window.confirm(t('request.action.chslot_confirm') ?? undefined)) return;
    //  }
        setIsLoading(true);
        setError('');
        const result = await put('/requests/' + request.id, { slot_id: slot.id });
        if(result.error) {
            setError(result.error.text[lang]);
        }
        if(result.data) {
            dispatch(requestsPut(result.data.request as Request));
        }
        setIsLoading(false);
    };

    // Отрисовка отдельного слота
    const drawSlot = (slot: Slot) => {
        if(!currentDate || !slot.start.startsWith(currentDate)) return null;

        const [ hour, min ] = slot.start.split('T')[1].split(':');
        const time = `${hour}:${min}`;
        const duration = lang === 'en' ? slot.duration + ' min' : slot.duration + ' мин';
        const line = <div><span>{time}</span><span>{duration}</span></div>;

        if(slot.id === request.slot_id) {
            return  <li key={slot.id} className='current'>{line}<div>{t('request.slot.current')}</div></li>;
        }
        if(otherRequests.find(r => r.slot_id === slot.id)) {
            return  <li key={slot.id} className='disabled'>{line}<div>{t('request.slot.disabled')}</div></li>;
        }
        if(myRequests.find(r => r.slot_id === slot.id && (r.status === 'approved' || r.status === 'negotiation'))) {
            return  <li key={slot.id} className='disabled'>{line}<div>{t('request.slot.busy')}</div></li>;
        }
        return <li key={slot.id} onClick={() => changeSlot(slot)}>{line}<div>{t('request.slot.free')}</div></li>;
    };

    return (
        <div className='RequestChangeSlot'>
            {error ? <div className='error'>{error}</div> : <>
                <DateSwitch current={currentDate} onChange={setCurrentDate} className='white'/>
                <ul className='Slots'>
                {slots.map(slot => drawSlot(slot))}
                </ul>
            </>}

            <span className='Cancel' onClick={() => onClose()}>
                <Icon icon={faArrowLeft} fixedWidth/> {t('request.action.chslot_cancel')}
            </span>
        </div>
	);
};

export default RequestChangeSlot;
